const PlayMobile = () => (
  <svg fill="none" height="84" viewBox="0 0 84 84" width="84" xmlns="http://www.w3.org/2000/svg">
    <ellipse cx="42" cy="42" fill="black" fill-opacity="0.4" rx="40.5" ry="40" />
    <path d="M58 42L34 55.8564L34 28.1436L58 42Z" fill="#EEDFAF" />
    <circle cx="41.75" cy="41.75" r="38.25" stroke="url(#paint0_linear_7647_873)" stroke-width="7" />
    <circle cx="41.75" cy="41.75" r="33.75" stroke="url(#paint1_linear_7647_873)" stroke-width="2" />
    <defs>
      <linearGradient gradientUnits="userSpaceOnUse" id="paint0_linear_7647_873" x1="42" x2="42" y1="7" y2="76.5">
        <stop stop-color="#FFD789" />
        <stop offset="0.25" stop-color="#956C42" />
        <stop offset="0.5" stop-color="#AD7C3F" />
        <stop offset="0.75" stop-color="#6C4B2B" />
        <stop offset="1" stop-color="#A97948" />
      </linearGradient>
      <linearGradient gradientUnits="userSpaceOnUse" id="paint1_linear_7647_873" x1="41.75" x2="41.75" y1="7" y2="76.5">
        <stop stop-color="#8E663D" />
        <stop offset="1" stop-color="#EBC067" />
      </linearGradient>
    </defs>
  </svg>
);

export default PlayMobile;
